export const DATA_ASSISTANT_MANAGE_PERMISSION = 'data_assistant_manage';
export const CALL_RECORDING_ACCESS_PERMISSION = 'call_recording_access';
export const ACCESS_ALL_REPORTS_PERMISSION = 'access_all_reports';
export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  DATA_ASSISTANT_MANAGE_PERMISSION,
  CALL_RECORDING_ACCESS_PERMISSION,
  ACCESS_ALL_REPORTS_PERMISSION,
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = ACCESS_ALL_REPORTS_PERMISSION;

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
